/** Shape aligned with ModelSelectorContext.CompanyModelSelection. */
export interface CompanyModelSelectionFromTree {
  id: string;
  name: string;
  description?: string;
  businessModelId: string;
  businessModelName: string;
  artifactTreeId: string;
  artifactTreeName: string;
  artifactCount: number;
  lastUpdated: string;
}

/** Map an artifact tree API row into ModelSelector company-model shape. */
export function companyModelSelectionFromTree(
  tree: {
    id?: string;
    name?: string;
    description?: string;
    business_model_id?: string;
    businessModelId?: string;
    artifact_count?: number;
    artifactCount?: number;
    updated_at?: string;
    lastUpdated?: string;
  },
  companyName?: string
): CompanyModelSelectionFromTree | null {
  const treeId = typeof tree.id === 'string' ? tree.id.trim() : '';
  if (!treeId) return null;
  const treeName =
    (typeof tree.name === 'string' && tree.name.trim()) ||
    (companyName ? `${companyName} tree` : 'Company tree');
  const businessModelId =
    (typeof tree.businessModelId === 'string' && tree.businessModelId) ||
    (typeof tree.business_model_id === 'string' && tree.business_model_id) ||
    treeId;
  const artifactCount =
    typeof tree.artifactCount === 'number'
      ? tree.artifactCount
      : typeof tree.artifact_count === 'number'
        ? tree.artifact_count
        : 0;
  const lastUpdated =
    (typeof tree.lastUpdated === 'string' && tree.lastUpdated) ||
    (typeof tree.updated_at === 'string' && tree.updated_at) ||
    new Date().toISOString();

  return {
    id: `company-model-${treeId}`,
    name: companyName ? `${companyName} model` : treeName,
    description: typeof tree.description === 'string' ? tree.description : undefined,
    businessModelId,
    businessModelName: treeName,
    artifactTreeId: treeId,
    artifactTreeName: treeName,
    artifactCount,
    lastUpdated,
  };
}
